import { getExtensionFromFileName } from './getExtensionFromFileName';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

// If this is changed, also update the list of extensions in fileProviderItemsSupportedActions.ts
export function isFluidFile(fileName: string | undefined): boolean {
    const extension = (getExtensionFromFileName(fileName) || fileName || '').toLowerCase();
    return !fileName ? false : isGlobalFeatureEnabled('cmp-prague') && isFluidExtension(extension);
}

export function isFluidExtension(extension: string): boolean {
    if (extension.startsWith('.')) {
        extension = extension.substring(1);
    }
    return (
        extension === 'fluid' ||
        extension === 'note' ||
        extension === 'loop' ||
        extension === 'whiteboard'
    );
}
